import styled from 'styled-components';
export const ChipWrapper = styled.div `
  display: flex;
  align-items: center;
  border-radius: 99px;
  padding: 0px 10px;
  max-width: fit-content;
  min-height: 30px;
  ${({ theme, variant }) => theme.chip[variant]}
`;
export const ChipText = styled.p `
  ${({ theme }) => theme.typography.TextLink};
  ${({ theme }) => theme.fonts.PoppinsBold};
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  color: white;
  margin: 0px 8px;
`;
export const RemoveButton = styled.button `
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  outline: none;

  &:disabled {
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=BKJChip.styled.js.map